import React from 'react'
import styled from 'styled-components'
import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'
import get from 'lodash/get'
import set from 'lodash/set'
import maxBy from 'lodash/maxBy'
import moment from '../../../lib/moment.js'
import AlignedComponent from './aligned-component'

class MixedChart extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'efficiencySummary')) !== JSON.stringify(get(prevState, 'efficiencySummary'))) {
      set(tempState, 'efficiencySummary', get(nextProps, 'efficiencySummary'))
    }
    return tempState
  }

  state={}

  componentDidMount() {
    this.forceUpdate()
  }

  renderChart = () => {
    const efficiencySummary = get(this.state, 'efficiencySummary', [])
    const months = []
    const chargeable = []
    const headcount = []
    const nonChargeable = []
    const chargeablePercent = []
    const onProjectPercent = []
    const internalsAndNonCharge = []
    const utilizationPercent = []
    const internalsPercent = []
    const chargeableDiffOnProject = []
    const onProject = []
    efficiencySummary.map(summary => {
      months.push(moment(get(summary, 'month'), 'YYYY-MM').format('MMM'))
      chargeable.push(parseFloat(get(summary, 'chargeable', 0)).toFixed(2))
      headcount.push(parseFloat(get(summary, 'headcount', 0)).toFixed(2))
      nonChargeable.push(parseFloat(get(summary, 'nonChargeable', 0)).toFixed(2))
      chargeablePercent.push(parseFloat(get(summary, 'chargeablePercent', 0)).toFixed(2))
      onProjectPercent.push(parseFloat(get(summary, 'onProjectPercent', 0)).toFixed(2))
      internalsAndNonCharge.push(parseFloat(get(summary, 'internalsAndNonCharge', 0)).toFixed(2))
      utilizationPercent.push(parseFloat(get(summary, 'utilizationPercent', 0)).toFixed(2))
      internalsPercent.push(parseFloat(get(summary, 'internalsPercent', 0)).toFixed(2))
      chargeableDiffOnProject.push((parseFloat(get(summary, 'chargeable', 0)).toFixed(4) - parseFloat(get(summary, 'onProject', 0)).toFixed(4)).toFixed(2))
      onProject.push(parseFloat(get(summary, 'onProject', 0)).toFixed(2))
      return summary
    })
    const maxValueLeft = chargeable && headcount && nonChargeable ?
      (parseInt(maxBy([...chargeable, ...headcount, ...nonChargeable], (val) => {
        return parseFloat(val)
      }) / 10, 10) + 1) * 10 : 0
    const stepLeft = maxValueLeft ? maxValueLeft / 5 : 0
    const chart = document.getElementById(get(this.props, 'idChart')).getContext("2d")

    // eslint-disable-next-line no-new
    new Chart(chart, {
      type: 'bar',
      data: {
        labels: months,
        datasets: [{
          label: "Chargeable (+Forecast) (%)",
          id: "y-axis-1",
          type: "line",
          yAxisID: 'y-axis-1',
          backgroundColor: '#CE152C',
          borderColor: '#CE152C',
          data: chargeablePercent,
          fill: false,
        }, {
          label: "Chargeable (on-project) (%)",
          id: "y-axis-1",
          type: "line",
          yAxisID: 'y-axis-1',
          backgroundColor: '#666633',
          borderColor: '#666633',
          data: onProjectPercent,
          fill: false,
        },
        //  {
        //   label: "Utillization (%)",
        //   id: "y-axis-2",
        //   type: "line",
        //   yAxisID: 'y-axis-1',
        //   backgroundColor: '#000',
        //   borderColor: '#000',
        //   data: utilizationPercent,
        //   fill: false,
        // },
        //  {
        //   label: "Chargeable",
        //   id: "y-axis-0",
        //   yAxisID: 'y-axis-0',
        //   stack: 3,
        //   type: "bar",
        //   backgroundColor: "#5CB85C",
        //   data: chargeable,
        // }, 
        {
          label: "Chargeable (on-project)",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          stack: 3,
          type: "bar",
          backgroundColor: "#92D050",
          data: onProject,
        },
        {
          label: "Chargeable (+Forecast)",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          stack: 3,
          type: "bar",
          backgroundColor: "#F598A4",
          data: chargeableDiffOnProject,
        },
        {
          label: "Internal Project",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          stack: 3,
          type: "bar",
          backgroundColor: "#7030A0",
          data: internalsAndNonCharge,
        },{
          label: "Non-Chargeable",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          stack: 3,
          type: "bar",
          backgroundColor: '#0070C0',
          data: nonChargeable,
        },
        // {
        //   label: "Headcount",
        //   id: "y-axis-0",
        //   yAxisID: 'y-axis-0',
        //   stack: 1,
        //   type: "bar",
        //   backgroundColor: "#FFD600",
        //   data: headcount,
        //   hidden: true,
        // },
        ],
      },
      options: {
        animation: {
          duration: 0
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
        maintainAspectRatio: false,
        legend: {
          labels: {
            boxWidth: 15,
          },
        },
        tooltips: {
          mode: 'label',
        },
        chartArea: {
          backgroundColor: '#EDEFF5',
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true,
            position: "left",
            id: "y-axis-0",
            ticks: {
              beginAtZero: true,
              stepSize: stepLeft,
              max: maxValueLeft,
            },
            afterFit: (scaleInstance) => {
              const width = scaleInstance
              width.width = get(this.props, 'widthLeft')
            },
          }, {
            display: true,
            stacked: false,
            position: "right",
            id: "y-axis-1",
            ticks: {
              beginAtZero: true,
              stepSize: 20,
              max: 100,
              callback: (value) => { return `${value} %` },
            },
            afterFit: (scaleInstance) => {
              const width = scaleInstance
              width.width = 50
            },
          }],
        },
      },
      plugins: [{
        beforeDraw: (chartInstance /* easing */) => {
          const ctx = chartInstance.chart.ctx
          ctx.fillStyle = '#EDEFF5'
          const chartArea = chartInstance.chartArea
          ctx.fillRect(
            chartArea.left + (((chartArea.right - chartArea.left) / 13) * 6),
            chartArea.top,
            ((chartArea.right - chartArea.left) / 13),
            chartArea.bottom - chartArea.top)
        },
      }, {
        beforeDraw: (chartInstance /* easing */) => {
          const ctx = chartInstance.chart.ctx
          ctx.fillStyle = '#F8E3E2'
          const chartArea = chartInstance.chartArea
          ctx.fillRect(
            chartArea.left,
            chartArea.top,
            chartArea.right - chartArea.left,
            ((chartArea.bottom - chartArea.top) / 10) * 3)
        },
      }],
    })
  }

  render() {
    if (document.getElementById(get(this.props, 'idChart')) !== null) {
      this.renderChart()
    }
    return (
      <AlignedComponent padding={ 0 }>
        <Wrapper style={ { height: 400 } }>
          <canvas id={ get(this.props, 'idChart') } width='100%' height={ 400 } />
        </Wrapper>
      </AlignedComponent>
    )
  }
}

MixedChart.propTypes = {
}
MixedChart.defaultProps = {
}

export default MixedChart

const Wrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`
// const ContainerChart = styled.div`
//   display: flex;
//   background-color: #ffffff;
//   justify-content: flex-end;
//   padding-left: 120px;
//   padding-right: 50px ;
// `
// const ChartContainer = styled.div`
//   width: 100%;
//   background-color: #FFFFFF;
//   -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
//   -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
//   box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
// `



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/components/mixed-chart.js